
document.addEventListener("DOMContentLoaded", function () {
    const logo = document.querySelector(".header__heading-logo-wrapper img");
    const header = document.querySelector(".header__heading-logo-wrapper");

    window.addEventListener("scroll", function () {
        if (window.scrollY > 50) {
        logo.classList.add("shrink-r84");
        } else {
        logo.classList.remove("shrink-r84");
        }
    });
});